function filter01() {
    return [
        {
            fieldName: 'id',
            type: "value",
            value: 1
        }
    ]
}
function filterRows() {
    return [
        {
            fieldName: 'idCustomerOrder',
            type: "value",
            value: localStorage.getItem('idCustomerOrder')
        }
    ]
}
function visibleUser() {
    return [
        {
            fieldName: 'visible',
            type: "value",
            value: 1
        }
    ]
}
export const customFilters = {
    filter01: filter01,
    filterRows: filterRows,
    visibleUser: visibleUser
};